import type { QuestionnaireData, AIGeneratedQuestion } from '@data/publicPlans';

/** Maps questionnaire + built questions into plan API fields so drafts keep AI analysis and Smart Questions. */
export function buildAiQuestionnairePersistenceForPlanApi(input: {
	questionnaireData: QuestionnaireData;
	allQuestions: AIGeneratedQuestion[];
}): {
	ai_analysis?: QuestionnaireData['aiAnalysis'];
	ai_questions?: AIGeneratedQuestion[];
	ai_answers?: Record<string, unknown>;
} {
	const analysis = input.questionnaireData.aiAnalysis;
	const questions =
		input.allQuestions.length > 0
			? input.allQuestions
			: Array.isArray(analysis?.suggestedQuestions) && analysis.suggestedQuestions.length > 0
				? analysis.suggestedQuestions
				: undefined;
	const mergedAnswers: Record<string, unknown> = { ...(input.questionnaireData.aiAnswers || {}) };
	if (input.questionnaireData.aiQuestionComments) {
		for (const [k, v] of Object.entries(input.questionnaireData.aiQuestionComments)) {
			mergedAnswers[`ai_q_${k}_comment`] = v;
		}
	}
	const out: {
		ai_analysis?: QuestionnaireData['aiAnalysis'];
		ai_questions?: AIGeneratedQuestion[];
		ai_answers?: Record<string, unknown>;
	} = {};
	if (analysis) out.ai_analysis = analysis;
	if (questions && questions.length > 0) out.ai_questions = questions;
	if (Object.keys(mergedAnswers).length > 0) out.ai_answers = mergedAnswers;
	return out;
}
